// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"modal_modalContainer__2Xh0E","modalContent":"modal_modalContent__3karO","modalBtnClose":"modal_modalBtnClose__2XafH"};